export default "__VITE_PUBLIC_ASSET__adc9f9d7__"